import React, { useCallback, useContext, useRef } from "react";

import NavigationMenuContext from "../NavigationMenuContext";

import { Button } from "../../Button";

import { generateClassString as gcs } from "../../../lib/helper/generateClassString";

import * as styles from "./mainNavigation.module.less";
import { PhoneContactButton } from "../PhoneContactButton/PhoneContactButton";
import GeneralPageContext from "../../../templates/GeneralPageContext";

export function MainNavigation({ mainNavElements }) {
    const {
        currentSlug,
        layout: { slimTopBar }
    } = useContext(GeneralPageContext);

    const {
        navigationReducer: {
            navState: {
                navigationOpen,
                activeLayer: { id: activeLayerId, subNavElements: activeSubNav }
            },
            dispatch
        },
        isMobile,
        setIsBackLink
    } = useContext(NavigationMenuContext);

    const timerRef = useRef();

    const clearTimerRef = useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current.timer);
            timerRef.current = undefined;
        }
    }, [timerRef]);

    const handleMouseEnter = useCallback(
        (id, callback) => {
            // TODO: should go in an upper state, which will not be reset on clicking a Nav-Link with Route change
            if (document.lastId === id) {
                document.lastId = undefined;
                return;
            }
            document.lastId = id;

            clearTimerRef();

            timerRef.current = { timer: setTimeout(callback, 400), id: id };
            setIsBackLink(false);
        },
        [timerRef]
    );

    const handleMouseLeave = (id) => {
        if (timerRef?.current?.id === id) {
            clearTimerRef();
        }

        if (!activeSubNav?.length) {
            dispatch({ type: "closeSubNav" });
        }
    };

    return (
        <div
            className={gcs(
                styles.mainNavWrapper,
                [isMobile, styles.mobileMainNav],
                [isMobile && (!navigationOpen || activeLayerId), styles.hidden]
            )}
        >
            <div className={styles.mainNavContainer}>
                <div className={styles.maiNavItemContainer}>
                    {mainNavElements.sort((a,b) => a.position - b.position).map(
                        ({
                            id,
                            name,
                            link,
                            externalUrl,
                            treeChildren: subNavElements
                        }) => {
                            const navigate = () =>
                                dispatch({ type: "navigate", to: id });

                            const hasSubNavigation = subNavElements.length > 0;

                            const additionalProps = {
                                ...(isMobile
                                    ? { onClick: navigate }
                                    : {
                                          onMouseEnter: () =>
                                              handleMouseEnter(id, navigate),
                                          onMouseLeave: () =>
                                              handleMouseLeave(id)
                                      }),
                                ...((!isMobile || !hasSubNavigation) && {
                                    to: link?.url || externalUrl
                                })
                            };

                            const active =
                                activeLayerId === id ||
                                link?.url === currentSlug;

                            return (
                                <Button
                                    className={styles.navElementsCommon}
                                    key={id}
                                    type={"secondary"}
                                    icon={
                                        isMobile && hasSubNavigation
                                            ? "chevronRight"
                                            : ""
                                    }
                                    iconPosition={"right"}
                                    renderAs={
                                        isMobile && hasSubNavigation
                                            ? "button"
                                            : "link"
                                    }
                                    active={active}
                                    {...additionalProps}
                                >
                                    {name}
                                </Button>
                            );
                        }
                    )}
                </div>

                {!slimTopBar && (
                    <PhoneContactButton className={styles.phoneNumber} />
                )}
            </div>
        </div>
    );
}
